








































































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {$, Helper, MixinQueryRouter} from 'simpli-web-sdk'
import {PontaSla} from '@/model/resource/PontaSla'
import {PontaSlaCollection} from '@/model/collection/PontaSlaCollection'
import {ListPontaSlaSchema} from '@/schema/resource/PontaSla/ListPontaSlaSchema'
import {CsvPontaSlaSchema} from '@/schema/resource/PontaSla/CsvPontaSlaSchema'

@Component
export default class ListPontaSlaView extends Mixins(MixinQueryRouter) {
  schema = new ListPontaSlaSchema()
  collection = new PontaSlaCollection()

  async created() {
    await this.query()
  }

  goToPersistView(item: PontaSla) {
    Helper.pushByName('editPontaSla', item.$id)
  }

  async downloadCsv() {
    const {params} = this.collection
    delete params.ascending
    delete params.orderBy
    delete params.page
    delete params.limit

    const csv = new PontaSlaCollection().clearFilters().addFilter(params)

    await csv.listCsvPontaSla()
    new CsvPontaSlaSchema().downloadCsv(csv.all())
  }
}
